window._ = require("lodash");
window.Vue = require("vue");

import news from "./vue/news";

new Vue({
    el: "#vue-app",
    components: {
        news
    }
});



// WEBPACK FOOTER //
// ./assets/js/vue.js